import { TBasketItem } from '../types';
import { SEND_ERROR_SNACK, SEND_SUCCESS_SNACK } from '../components/BasketLogicSnackbar/consts';

type TParams = {
  e: CustomEvent;
  countMainProduct: number;
  countMainProductInBasket: number;
  mainProductId: string;
};

export const sendBasketSnackbar = ({
  e,
  countMainProduct,
  countMainProductInBasket,
  mainProductId,
}: TParams) => {
  const { detail } = e;
  const mainProductInEvent = detail.find((el: TBasketItem) => el.code === mainProductId);
  const resultAdding = mainProductInEvent?.quantity - countMainProductInBasket;

  if (mainProductInEvent?.quantity && resultAdding === countMainProduct) {
    document.body.dispatchEvent(new CustomEvent(SEND_SUCCESS_SNACK));
  } else {
    document.body.dispatchEvent(new CustomEvent(SEND_ERROR_SNACK));
  }
};
